var _defs, _path, _polygon, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _polygon2, _polygon3, _path39, _path40, _path41, _path42, _path43, _path44, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _polygon4, _path45, _path46, _polygon5, _path47, _path48, _path49, _path50, _path51, _path52, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _polygon6, _path53, _path54, _polygon7, _path55, _path56, _path57, _path58, _path59, _path60, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _polygon8, _path61, _path62, _path63, _path64, _path65, _path66, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path67, _path68, _path69, _path70, _path71, _rect19, _rect20, _path72, _path73, _path74, _circle, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _polygon9, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _circle2, _circle3, _g, _path97, _path98, _path99, _path100, _path101, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _circle4, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _ellipse7, _path123, _polygon15, _polygon16, _polygon17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawBooks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "2cf41747-0c0c-4d70-aad4-093c093adad4",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1022.84,
    height: 813.16,
    viewBox: "0 0 1022.84 813.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "3cf802be-0480-4c68-848a-073112220499",
    x1: 635.22,
    y1: 545.34,
    x2: 635.22,
    y2: 43.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "book lover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M688.44,180.84c-64.72-2.25-126.37-23.14-185.23-46S386.05,86.65,322.88,74.54c-40.63-7.79-87.1-8.89-119.83,12.89-31.51,21-41.69,57.15-47.16,90.73-4.12,25.26-6.54,51.84,4.75,75.49,7.83,16.42,21.74,30.22,31.35,46,33.47,54.72,9.82,122.2-26.45,175.63-17,25.07-36.75,49-49.87,75.66s-19.2,57.25-7.72,84.47c11.39,27,38.52,47.24,67.9,61.49,59.69,28.95,130,37.23,198.61,41.92,151.83,10.39,304.46,5.89,456.69,1.39,56.34-1.67,112.92-3.36,168.34-12.07,30.78-4.84,62.55-12.51,84.9-31.05,28.36-23.53,35.39-63.38,16.39-92.88-31.89-49.49-120-61.78-142.32-114.9-12.26-29.23.34-61.79,18.16-88.91,38.24-58.16,102.33-109.19,105.71-175.67,2.32-45.67-28.5-91.39-76.14-113C956.26,89,887,91.88,850.18,129.37,812.24,168,745.58,182.82,688.44,180.84Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6",
    opacity: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "435.45 690.5 93.17 688.83 59.16 609.06 179.42 600.33 158.46 512.87 396.32 482.04 168.55 402.86 188.67 398.08 554.92 457.83 534.75 594.32 505.92 669.33 435.45 690.5",
    fill: "#7342d6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187,698.84s21-3.36,33.6,11.48c0,0-9.24,7.28-29.12-2.8Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184.8,698.51S171.4,715,178,733.36c0,0,10.92-4.37,12.11-26.63Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.76,671.4s8.4-15.41,42,6.16c0,0-4.48,10.36-19.32,9.52S176.68,679.52,172.76,671.4Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170.59,670.29s-17.43-2-19.12,37.9c0,0,11.05,2.29,18.9-10.33S175,678.16,170.59,670.29Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.44,638.46s9.8-27.16,45.36-7.84c0,0-8.12,24.92-41.72,17.08Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.52,597.86s18.48-27.44,51.24-2c0,0-11.48,25.76-48.44,11.76Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.6,559.22s21.56-25.21,54,0c0,0-20.44,22.12-54,6.44Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.24,521.69s21.84-26.32,52.92-1.4c0,0-24.64,23.24-52.92,7.56Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M144.2,488.37s23-33.88,52.08-10.92c0,0-24.64,29.12-52.08,17.36Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M149.52,449.45s24.36-33.6,52.64-7.84c0,0-28.84,29.12-52.64,14Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M157.64,414.66s28.84-31.58,54-19c0,0-30.05,33.54-55.26,27.38Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M167.72,381.68S201,343,220.36,355.92c0,0-24.52,30-55,33Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M182.27,343.43s29.13-31.58,50.41-23.74c0,0-24.92,32.76-54.32,33.6Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M195.44,307.65s32.2-30.24,46.2-24.92c0,0-23.24,33.6-47.6,31.64Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M208.32,274.61s27.72-36.13,42.85-33.33c0,0-16.81,32.21-42.85,37Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M222.3,230.06s24.5-27.69,37.74-27.63c0,0-19.34,37-38.75,36.66Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M230.58,200.4l23.67-57.68s1.18,52.14-26.68,68.38Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M240.19,136.79s3.92-48.17,1.4-52.09c0,0,16.92,40.05-1.56,73.37Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M159.52,637.82s-24.54-15.21-40.43,22c0,0,21.84,14.5,43.32-12.51Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M148.73,596.31s-30.1-13.73-44.7,25.12c0,0,23.25,16,47.44-15.3Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M144.2,561.53s-21.56-25.21-54,0c0,0,20.44,22.12,54,6.44Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M141.5,521.69s-21.84-26.32-52.92-1.4c0,0,24.64,23.24,52.92,7.56Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M144.2,489.33s-15.32-37.95-48.62-21.63c0,0,18,33.65,47.26,27.93Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M151.45,449.26s-15.23-38.61-49-20.71c0,0,20.68,35.39,47.5,26.67Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M160.89,414.85s-6-42.33-34-46.12c0,0,5.94,44.64,30.23,53.75Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M168.43,381.76s-2.34-51-25.49-52.78c0,0,.78,38.71,22.88,60Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M184.67,342s-6.9-42.41-29-47.59c0,0,2.74,41.07,26.81,58Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M198.06,308s-.23-44.18-13.73-50.67c0,0-8.37,40,9.82,56.31Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M209.35,274.11s-1.89-45.49-15.87-51.9c0,0-4.78,36,13.78,54.88Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M224.25,233.69s-.08-37-10.06-45.68c0,0-9.92,40.53,4.85,53.12Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M229.41,198.58,219.7,137s-13.19,50.46,10.17,72.7Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M231.3,137.37s-24.92-41.4-24.41-46c0,0,2.65,43.39,34,65Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M234.22,125.14s-23.52-58.8-34.16-63.56c0,0,33.6,17.08,36.12,61.88Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M221.17,239.44l-1.61-.49c19.85-64.73,24.8-106,13.95-116.35l1.15-1.22C246.17,132.3,241.5,173.12,221.17,239.44Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#444053"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M166.51,391l-2.38-.85c2.11-5.93,4.38-11.95,6.76-17.88,20.72-51.64,38.36-99.68,49.67-136.56l2.07-1c-11.33,36.95-28.66,86.83-49.4,138.54C170.86,379.07,168.6,385.06,166.51,391Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#444053"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M216.59,747.28c-.32-.35-32.49-36.58-54.92-98.43A364.18,364.18,0,0,1,140,536.07c-1.54-48.13,8.56-101.87,25.86-150.69l1.88,2.2c-38.84,109.57-23.41,203.46-2.94,260,22.19,61.29,54,97.12,54.31,97.48Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#444053"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M719.31,670.36s-22.67,27.67-4.67,69.5l-181,78.5L516.27,822l-8-35,5.35-44.17V718.69Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#d5d6db"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "59.16 609.06 309.68 563.39 641.63 616.27 435.45 690.5 59.16 609.06",
    fill: "#7342d6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "59.16 609.06 309.68 563.39 641.63 616.27 435.45 690.5 59.16 609.06",
    fill: "#7342d6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M147.74,652.47s-23.43,44.39,3.57,85.39l371.5,80.5S499.75,783,524,733.92Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M147.74,652.47s-23.43,44.39,3.57,85.39l371.5,80.5S499.75,783,524,733.92Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M158.81,667.86s-13.39,32.48,0,53.5",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M522.81,818.36l207.4-88.5s11.6,2.5,4.1,11-207.5,86-207.5,86l-375.5-89Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M522.81,818.36l207.4-88.5s11.6,2.5,4.1,11-207.5,86-207.5,86l-375.5-89Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M505.81,742.86s-20,24,0,60",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 510.68,
    y: 757.36,
    width: 94.57,
    height: 1,
    transform: "translate(-299.77 172.15) rotate(-18.45)",
    opacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 509.35,
    y: 759.86,
    width: 115.23,
    height: 1,
    transform: "translate(-321.85 207.81) rotate(-20.82)",
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 508.7,
    y: 764.61,
    width: 133.56,
    height: 1,
    transform: "translate(-335.51 231.58) rotate(-22.26)",
    opacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 508.37,
    y: 766.53,
    width: 153.74,
    height: 1,
    transform: "translate(-352.49 265.59) rotate(-24.31)",
    opacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 509.21,
    y: 768.64,
    width: 168.15,
    height: 1,
    transform: "translate(-346.96 258.59) rotate(-23.61)",
    opacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 510.33,
    y: 769.26,
    width: 201.22,
    height: 1,
    transform: "translate(-343.72 261.93) rotate(-23.36)",
    opacity: 0.1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "152.23 613.94 328.23 576.94 435.45 597.44 291.23 643.94 152.23 613.94",
    fill: "#fff",
    opacity: 0.3
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M730.21,659.69s9.1,3.67,3.76,9.34S524,733.92,524,733.92Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M818.6,574.18s-22.66,27.66-4.66,69.5l-181,78.5-17.37,3.66-8-35L613,646.68V622.51Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#d5d6db"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.46 512.87 408.97 467.21 740.93 520.09 534.75 594.32 158.46 512.87",
    fill: "#3a3768"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M247,556.29s-23.44,44.39,3.56,85.39l371.5,80.5s-23.05-35.39,1.23-84.45Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#3a3768"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M247,556.29s-23.44,44.39,3.56,85.39l371.5,80.5s-23.05-35.39,1.23-84.45L505.81,612.3Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M258.1,571.68s-13.38,32.47,0,53.5",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M622.1,722.18l207.41-88.5s11.59,2.5,4.09,11-207.5,86-207.5,86l-375.5-89Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#3a3768"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M622.1,722.18l207.41-88.5s11.59,2.5,4.09,11-207.5,86-207.5,86l-375.5-89Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M605.1,646.68s-20,24,0,60",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 609.97,
    y: 661.18,
    width: 94.57,
    height: 1,
    transform: "translate(-264.22 198.64) rotate(-18.45)",
    opacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 608.65,
    y: 663.68,
    width: 115.23,
    height: 1,
    transform: "translate(-281.17 236.83) rotate(-20.82)",
    opacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 608,
    y: 668.43,
    width: 133.56,
    height: 1,
    transform: "translate(-291.68 262.02) rotate(-22.26)",
    opacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 607.66,
    y: 670.34,
    width: 153.74,
    height: 1,
    transform: "translate(-304.07 297.94) rotate(-24.31)",
    opacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 608.51,
    y: 672.45,
    width: 168.15,
    height: 1,
    transform: "translate(-300.13 290.3) rotate(-23.61)",
    opacity: 0.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 609.63,
    y: 673.07,
    width: 201.22,
    height: 1,
    transform: "translate(-297.44 293.41) rotate(-23.36)",
    opacity: 0.1
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "251.53 517.76 427.53 480.76 534.75 501.26 390.53 547.76 251.53 517.76",
    fill: "#fff",
    opacity: 0.45
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M829.51,563.51s9.09,3.67,3.76,9.33-209.94,64.89-209.94,64.89Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#3a3768"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M828,464.15s-22.67,49.67-4.67,91.5l-181,56.5L625,615.82l-8-35,5.35-44.17V512.48Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#d5d6db"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "167.89 402.85 418.41 357.18 750.37 410.06 544.18 484.29 167.89 402.85",
    fill: "#7342d6"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M256.47,446.26S233,490.65,260,531.65l371.5,80.5s-23.06-35.39,1.22-84.44Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M256.47,446.26S233,490.65,260,531.65l371.5,80.5s-23.06-35.39,1.22-84.44Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M267.54,461.65s-13.39,32.48,0,53.5",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M631.54,612.15l207.4-66.5s11.6,2.5,4.1,11-207.5,64-207.5,64l-375.5-89Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M631.54,612.15l207.4-66.5s11.6,2.5,4.1,11-207.5,64-207.5,64l-375.5-89Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M614.54,536.65s-20,24,0,60",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 619.41,
    y: 551.15,
    width: 94.57,
    height: 1,
    transform: "translate(-228.91 195.97) rotate(-18.45)",
    opacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 618.08,
    y: 553.65,
    width: 115.23,
    height: 1,
    transform: "translate(-241.44 233) rotate(-20.82)",
    opacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 617.43,
    y: 558.4,
    width: 133.56,
    height: 1,
    transform: "translate(-249.3 257.4) rotate(-22.26)",
    opacity: 0.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 617.1,
    y: 560.32,
    width: 153.74,
    height: 1,
    transform: "translate(-257.94 292.06) rotate(-24.31)",
    opacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 617.95,
    y: 562.43,
    width: 168.15,
    height: 1,
    transform: "translate(-255.27 284.87) rotate(-23.61)",
    opacity: 0.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 619.07,
    y: 563.05,
    width: 201.22,
    height: 1,
    transform: "translate(-253.04 288.14) rotate(-23.36)",
    opacity: 0.1
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "260.96 407.73 436.96 370.73 544.18 391.23 399.96 437.73 260.96 407.73",
    fill: "#fff",
    opacity: 0.3
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M838.94,453.48s9.1,3.67,3.76,9.34-209.94,64.89-209.94,64.89Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M399,149.92s-38-2.29-33.56,24.37c0,0-.89,4.71,3.38,6.85,0,0,.07-2,3.9-1.31a17.05,17.05,0,0,0,4.14.2,8.62,8.62,0,0,0,5.05-2.08h0s10.69-4.42,14.85-21.9c0,0,3.08-3.81,3-4.79L393.32,154s2.19,4.63.47,8.48c0,0-.21-8.31-1.45-8.12-.25,0-3.33,1.61-3.33,1.61s3.77,8.07.92,13.93c0,0,1.08-9.94-2.1-13.35l-4.52,2.64s4.41,8.33,1.42,15.13c0,0,.77-10.43-2.37-14.49l-4.1,3.2s4.15,8.21,1.62,13.85c0,0-.33-12.14-2.5-13.06,0,0-3.59,3.16-4.13,4.46,0,0,2.84,6,1.07,9.11,0,0-1.07-8.09-2-8.13,0,0-3.57,5.36-3.94,9a19.46,19.46,0,0,1,3.07-9.54,10.71,10.71,0,0,0-5.46,2.83s.55-3.79,6.35-4.12c0,0,2.95-4.07,3.74-4.31,0,0-5.77-.49-9.26,1.06,0,0,3.08-3.57,10.31-2l4-3.3s-7.58-1-10.8.11c0,0,3.71-3.16,11.89-.86l4.41-2.63s-6.47-1.39-10.32-.89c0,0,4.06-2.19,11.61.18l3.14-1.41s-4.73-.93-6.12-1.08-1.46-.53-1.46-.53a16.51,16.51,0,0,1,8.9,1S399.13,150.34,399,149.92Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M933.6,259.5s-38-2.29-33.56,24.37c0,0-.89,4.71,3.38,6.85,0,0,.07-2,3.9-1.31a17.62,17.62,0,0,0,4.14.2,8.59,8.59,0,0,0,5-2.08h0s10.7-4.42,14.85-21.9c0,0,3.08-3.81,3-4.79l-6.42,2.74s2.19,4.63.47,8.48c0,0-.21-8.31-1.44-8.12-.25,0-3.34,1.61-3.34,1.61s3.77,8.07.93,13.93c0,0,1.08-9.94-2.11-13.35l-4.52,2.64s4.41,8.33,1.42,15.13c0,0,.77-10.43-2.37-14.49l-4.09,3.2s4.14,8.21,1.61,13.85c0,0-.33-12.14-2.5-13.06,0,0-3.58,3.16-4.13,4.46,0,0,2.84,6,1.08,9.11,0,0-1.08-8.09-2-8.13,0,0-3.57,5.36-3.94,9a19.4,19.4,0,0,1,3.08-9.54,10.76,10.76,0,0,0-5.47,2.83s.56-3.79,6.35-4.12c0,0,2.95-4.07,3.74-4.32,0,0-5.76-.48-9.26,1.07,0,0,3.08-3.57,10.31-2l4-3.3s-7.59-1-10.8.11c0,0,3.7-3.16,11.89-.86l4.4-2.63s-6.47-1.39-10.32-.89c0,0,4.06-2.19,11.61.18l3.15-1.41s-4.74-.93-6.13-1.08-1.46-.53-1.46-.53a16.39,16.39,0,0,1,8.9,1S933.72,259.92,933.6,259.5Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6",
    opacity: 0.1
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M463,314.62s-16.56-34.33-37.64-17.41c0,0-4.55,1.52-4.33,6.29,0,0,1.75-.91,3,2.77a17.72,17.72,0,0,0,1.84,3.7,8.63,8.63,0,0,0,4.29,3.4h0s9.07,7.18,26.36,2.28c0,0,4.83.83,5.62.25l-5.52-4.27s-3,4.17-7.18,4.54c0,0,7.16-4.23,6.39-5.21-.16-.2-3-2.13-3-2.13s-5.21,7.23-11.71,7.6c0,0,9.2-3.9,10.62-8.35l-4.5-2.66s-5.13,7.92-12.52,8.62c0,0,9.48-4.41,11.49-9.13l-4.78-2s-5.15,7.62-11.31,8.17c0,0,10.44-6.21,10.18-8.56,0,0-4.51-1.58-5.91-1.43,0,0-3.82,5.39-7.42,5.39,0,0,6.53-4.89,6.13-5.68,0,0-6.42-.5-9.8,1a19.47,19.47,0,0,1,9.83-2,10.77,10.77,0,0,0-5.14-3.39s3.58-1.36,6.69,3.53c0,0,5,.59,5.59,1.16,0,0-2.39-5.26-5.44-7.55,0,0,4.62.93,6.73,8l4.85,1.92s-2.79-7.12-5.36-9.37c0,0,4.56,1.69,6.55,10l4.44,2.56s-1.93-6.33-4.25-9.44c0,0,3.89,2.48,5.5,10.22l2.77,2.06s-1.5-4.59-2-5.87-.25-1.54-.25-1.54a16.41,16.41,0,0,1,3.48,8.25S462.64,314.92,463,314.62Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6",
    opacity: 0.1
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M846.78,211s-16.55-34.33-37.64-17.41c0,0-4.54,1.52-4.33,6.29,0,0,1.76-.9,3,2.77a17.34,17.34,0,0,0,1.85,3.71,8.58,8.58,0,0,0,4.28,3.39h0s9.08,7.18,26.36,2.29c0,0,4.83.82,5.63.24L840.44,208s-3,4.18-7.17,4.55c0,0,7.15-4.24,6.38-5.22-.16-.2-3-2.13-3-2.13s-5.2,7.23-11.71,7.6c0,0,9.21-3.9,10.63-8.34L831,201.82s-5.12,7.91-12.52,8.62c0,0,9.48-4.42,11.5-9.14l-4.79-2s-5.15,7.63-11.3,8.17c0,0,10.43-6.21,10.17-8.55,0,0-4.5-1.59-5.9-1.43,0,0-3.82,5.38-7.43,5.38,0,0,6.54-4.89,6.14-5.68,0,0-6.42-.5-9.81,1a19.46,19.46,0,0,1,9.83-2,10.71,10.71,0,0,0-5.13-3.39s3.58-1.36,6.69,3.53c0,0,5,.6,5.59,1.17,0,0-2.39-5.27-5.45-7.56,0,0,4.62.94,6.73,8.05l4.86,1.92s-2.79-7.13-5.36-9.38c0,0,4.56,1.69,6.54,10l4.45,2.56s-1.94-6.32-4.26-9.44c0,0,3.9,2.48,5.5,10.22l2.77,2.06s-1.49-4.59-2-5.87-.25-1.53-.25-1.53a16.45,16.45,0,0,1,3.47,8.25S846.47,211.32,846.78,211Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6",
    opacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M899.67,380.81S883.12,346.47,862,363.39c0,0-4.54,1.52-4.33,6.29,0,0,1.76-.9,3,2.77a17.33,17.33,0,0,0,1.84,3.71,8.58,8.58,0,0,0,4.28,3.39h0s9.08,7.19,26.37,2.29c0,0,4.82.83,5.62.24l-5.52-4.27s-3,4.18-7.18,4.55c0,0,7.15-4.24,6.38-5.22-.16-.2-3-2.13-3-2.13s-5.2,7.23-11.71,7.61c0,0,9.21-3.91,10.63-8.35l-4.51-2.66s-5.12,7.92-12.52,8.62c0,0,9.48-4.42,11.5-9.14l-4.79-2s-5.15,7.62-11.3,8.17c0,0,10.44-6.21,10.18-8.56,0,0-4.51-1.59-5.91-1.43,0,0-3.82,5.38-7.43,5.38,0,0,6.54-4.89,6.14-5.68,0,0-6.42-.5-9.81,1a19.52,19.52,0,0,1,9.84-2,10.69,10.69,0,0,0-5.14-3.39s3.58-1.37,6.69,3.53c0,0,5,.59,5.59,1.16,0,0-2.39-5.26-5.44-7.56,0,0,4.62.94,6.73,8.05l4.85,1.92s-2.79-7.13-5.36-9.37c0,0,4.56,1.68,6.54,10l4.45,2.55s-1.94-6.32-4.26-9.44c0,0,3.9,2.48,5.51,10.23l2.77,2s-1.5-4.59-2-5.87-.25-1.53-.25-1.53a16.35,16.35,0,0,1,3.47,8.25S899.36,381.11,899.67,380.81Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.95,
    cy: 781.59,
    rx: 22.99,
    ry: 2.57,
    fill: "#7342d6",
    opacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.24,
    cy: 737.91,
    rx: 22.99,
    ry: 2.57,
    fill: "#7342d6",
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.83,
    cy: 810.6,
    rx: 22.99,
    ry: 2.57,
    fill: "#7342d6",
    opacity: 0.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 905.53,
    cy: 747.41,
    rx: 22.99,
    ry: 2.57,
    fill: "#7342d6",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 714.22,
    cy: 734.94,
    rx: 22.99,
    ry: 2.57,
    fill: "#7342d6",
    opacity: 0.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 590.46,
    cy: 793.66,
    rx: 27.19,
    ry: 4.67,
    fill: "#7342d6",
    opacity: 0.1
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M691.17,790.14s-37.86,19.56-18.3,42.6c0,0,1.84,5,7.16,4.65,0,0-1.06-1.94,3-3.49a19.51,19.51,0,0,0,4.09-2.17,9.61,9.61,0,0,0,3.66-4.89h0s7.74-10.36,1.74-29.53c0,0,.78-5.42.1-6.3l-4.6,6.31s4.75,3.19,5.3,7.88c0,0-5-7.87-6-7-.22.18-2.28,3.45-2.28,3.45s8.24,5.59,8.85,12.85c0,0-4.64-10.17-9.65-11.62L681.37,808s9,5.48,10,13.72c0,0-5.23-10.45-10.57-12.56l-2.11,5.41s8.68,5.52,9.48,12.38c0,0-7.26-11.47-9.87-11.11,0,0-1.64,5.08-1.42,6.65,0,0,6.13,4.1,6.24,8.13,0,0-5.66-7.15-6.53-6.68,0,0-.36,7.19,1.38,10.93,0,0-3-5.34-2.51-10.93a12,12,0,0,0-3.63,5.84s-1.63-3.95,3.74-7.59c0,0,.51-5.59,1.13-6.28,0,0-5.81,2.84-8.28,6.32,0,0,.91-5.19,8.79-7.77l2-5.48s-7.88,3.34-10.31,6.28c0,0,1.75-5.15,10.93-7.62l2.72-5s-7,2.36-10.42,5c0,0,2.65-4.43,11.26-6.47l2.21-3.15s-5.08,1.81-6.5,2.46-1.7.33-1.7.33a18.39,18.39,0,0,1,9.11-4.14S691.52,790.48,691.17,790.14Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M803.54,420.71C797,402.94,761,401.27,745.38,405.8c-11.1,3.23-34.5,6.87-47,8.7l-.81-.77c1.62-.48,1.66-1.66,1.46-3.41a53.37,53.37,0,0,1,.1-6.92c7.66,2.38,14.48-3.25,14.48-3.25h0c9-4,6.58-21.12,8.3-25.8,1.29-3.5,2.68-24.12,3.3-34.4l.13,0,.07-3.45c.09-1.49.13-2.36.13-2.36s.88-25.14,2.6-30.23c1.6-4.68,2.9-28.26,3.1-32,0-.32,0-.49,0-.49l-.13-2.18c.09-1.59.13-3.36.12-5.22,0-8.55-.89-19.32-1-21.06,0-.25,0-.55,0-.91.07-3.65-.39-21.93-15.94-28.84-5.73-2.56-12.62-5.61-19.29-8.58-1.72-14.85-5.65-29.62-5.31-44.58,0-2.25.2-4.5.42-6.74,0,.65-.07,1.31-.08,2,0,1.45,0,2.91,0,4.36.59-18.71,7.66-37.52,7-55.83-.06,1.79-.19,3.59-.36,5.39a58.13,58.13,0,0,0-1.92-18.39c-.6-2.11-1.41-4.29-3.14-5.7a12.93,12.93,0,0,0-5.48-2.17,110.21,110.21,0,0,0-14.39-2.68A22.22,22.22,0,0,0,668.5,74c-10.14-13.92-25.16-27-42.92-30-8.91-1.5-19.16-.25-25.22,6.12a18.92,18.92,0,0,0-1.78,1.8c-3.26,3.89-4.66,9-8,12.88-.22.26-.47.5-.71.75-6.54,5.85-16.73,7.07-24,12.32A28.81,28.81,0,0,0,562.28,81a60.88,60.88,0,0,0-7.84,9.53c-3.27,4.6-6.63,9.39-7.67,14.88-2.09,11,5.4,21.43,6.79,32.5,3.1,24.77-24.31,46.75-19.12,71.19a32.6,32.6,0,0,0,8.82,15.83C532.57,234.61,523.47,244,523.47,244l0,.56-1.69,0,.17,2h-.17l.93,10.85-.93,15.8s0,.17,0,.49v.08l0,.43s0,.17,0,.49h.06c.31,5.79,1.54,26.61,3,31,1.72,5.09,2.59,30.23,2.59,30.23s1.9,35.53,3.64,40.23-.73,21.77,8.3,25.8h0a19,19,0,0,0,9.07,3.76c-.46,3.74-.17,6.45,1.32,7.3a4.36,4.36,0,0,0,2.1.6,22.29,22.29,0,0,0-1.63,2.85A42.36,42.36,0,0,1,539.75,414c-9.7-4-41.89-13-51.24-6.67s-31.85,12.07-21.46,37.55S482.28,471,482.28,471a37,37,0,0,1,8.31,8.35c3.12,4.69,32.19,15.42,39.46,15.42a71.19,71.19,0,0,1,9.25.46s-7.89,6.92-6.84,10.94-2.4,36.2-2.4,36.2,8,8.06,11.42-2.51l.12.16c.64.87,4.1,4.8,10.61-.16a59.48,59.48,0,0,1,8.46-5.36l31.52-4.46a89.24,89.24,0,0,1,9.87-.07c5,.41,9.91-2.55,13-4.84,6.53,2.48,13.87,5.19,17.36,6.18,7.08,2,39.62,10.73,47.23,8a10.57,10.57,0,0,0,4.1-2.92l7.26.23-3.4.68s6.62.11,15.62.23l-.38.22,11.29-.1c16.52.15,35.08.2,37.52-.35,3.82-.85,23.67-.25,29.52,0l1.63,0s21.81-4.35,12.81-26.48c-6.92-17-28.19-21.94-37.63-23.3,2.66-.53,4.95-.94,6.47-1.18,6.59-1,19.39-7,20.43-9.05s11.77-8,14.54-11.39S810.11,438.48,803.54,420.71ZM622.89,470.44l-1.07.35-.72.24-1.38,1.36c-1.1-.74-2.28-1.52-3.51-2.32C618.38,470.2,620.61,470.33,622.89,470.44Zm95.31,28.18h0Z",
    transform: "translate(-88.58 -43.42)",
    fill: "url(#3cf802be-0480-4c68-848a-073112220499)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M686.65,365s15.3,40,24,36,6.34-21,8-25.66,3.5-40,3.5-40,.84-25,2.5-30.06c1.54-4.65,2.79-28.1,3-31.79,0-.32,0-.49,0-.49L726,244l-9.34-2.33-21.66,8-3,17.13-1.17,6.69-.5,2.85Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#be6f72"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M691.69,358.3s14.6,11.95,19,13,7.1,10.37,7.1,10.37",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M567,366.75s-15.3,40-24,36-6.34-21-8-25.66-3.5-40-3.5-40-.84-25-2.5-30.06c-1.54-4.65-2.79-28.1-3-31.79,0-.32,0-.49,0-.49l1.66-29,9.34-2.33,21.66,8,3,17.13,1.17,6.69.5,2.85Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#be6f72"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 543.9,
    y: 109.27,
    width: 34.15,
    height: 53.23,
    fill: "#3e373a"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 543.9,
    y: 109.27,
    width: 34.15,
    height: 53.23,
    opacity: 0.1
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M561,406.59s-11.67,12.83-7.34,15.16,32.34,46,32.34,46,92,11.33,109.35-5.67,17-47.37,17-47.37-13.94,3-15.46,1.37-9.87-9.49-9.87-9.49S569,399.43,561,406.59Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#4b4b5b"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M561,406.59s-11.67,12.83-7.34,15.16,32.34,46,32.34,46,92,11.33,109.35-5.67,17-47.37,17-47.37-13.94,3-15.46,1.37-9.87-9.49-9.87-9.49S569,399.43,561,406.59Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.02
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M726.62,244.42l-30,24-9.07.66-3.33.24-55.93,4.1-58-4.24-8.63-.63-11-.8-23-22s16.28-17.44,30.54-29.21c5.62-4.65,10.93-8.41,14.8-9.89l.66-.23A16.46,16.46,0,0,0,580,202c11.26-11.61,21.67-40.26,21.67-40.26s49.67-25.66,43.67,8,22.33,25.34,22.33,25.34l9.34,4.26,3.69,1.69,9.41,4.31,21.23,9.74C728,222.75,726.62,244.42,726.62,244.42Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#be6f72"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 537.38,
    cy: 101.06,
    r: 44.67,
    opacity: 0.1
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M726.69,276.24H526c0-.32,0-.49,0-.49l1.66-29s16.28-17.44,30.54-29.21l126-5,5.86-6.18,21.23,9.74c16.67,7.66,15.33,29.33,15.33,29.33S728.9,270.54,726.69,276.24Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M726.69,275.24H526c0-.32,0-.49,0-.49l1.66-29s16.28-17.44,30.54-29.21l126-5,5.86-6.18,21.23,9.74c16.67,7.66,15.33,29.33,15.33,29.33S728.9,269.54,726.69,275.24Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#e7c7ca"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M593.79,193.92s31.66,40.34,73.83-.83,4.67,91.83,4.67,91.83l-91,10.8Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M593.79,195.92s31.66,40.34,73.83-.83,4.67,91.83,4.67,91.83l-91,10.8Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#e7c7ca"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M680.65,203,684,254.09l3.59,17,2.74,13s7,100,5,105,1,9,1.42,11.66-.42,9.34-.09,12.34,0,4.33-7.66,3.26-18.34-2.93-18.34-2.93-27,2-36.33-1.33-27-3.34-27-3.34-26.67.67-35.33-.33-13.34,10.67-19,7.33,6.66-35.66,10.66-45-5.33-33-5.33-33l12-66.57L573,256.09V208.65l.66-.23A16.46,16.46,0,0,0,580,204l3,47.74,94,3.34V201.35",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M680.65,201,684,252.09l3.59,17,2.74,13s7,100,5,105,1,9,1.42,11.66-.42,9.34-.09,12.34,0,4.33-7.66,3.26-18.34-2.93-18.34-2.93-27,2-36.33-1.33-27-3.34-27-3.34-26.67.67-35.33-.33-13.34,10.67-19,7.33,6.66-35.66,10.66-45-5.33-33-5.33-33l12-66.57L573,254.09V206.65l.66-.23A16.46,16.46,0,0,0,580,202l3,47.74,94,3.34V199.35",
    transform: "translate(-88.58 -43.42)",
    fill: "#e7c7ca"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M691.46,94.38c-.57-2.09-1.36-4.26-3-5.66a12.28,12.28,0,0,0-5.28-2.16A104.32,104.32,0,0,0,669.3,83.9a22.22,22.22,0,0,0-3-6.23C656.5,63.83,642,50.78,624.94,47.83c-8.93-1.55-19.28-.16-25,6.88-3.14,3.87-4.49,9-7.66,12.8-6.11,7.38-17.14,8.29-24.84,14-4.11,3-7.09,7.35-10,11.57-3.15,4.57-6.39,9.33-7.39,14.79-2,10.91,5.21,21.31,6.54,32.32,3,24.63-23.4,46.48-18.41,70.78,2.91,14.17,16,24.15,29.54,29.21,4.77,1.79,10.22,3.57,12.45,8.15,1,2,1.17,4.31,2.11,6.33,3.16,6.74,13.55,7,19.13,2.09s7.34-12.85,8-20.26c2.68-32.36-10.28-64.33-8.77-96.77.45-9.81,3.21-20.94,12-25.38,11.83-6,26.06,4,39.08,2.09a77.53,77.53,0,0,1,3.74,47.31c-2.07,8.63-5.65,17-5.91,25.9-.39,13.55,6.92,25.93,13.24,37.91a20.17,20.17,0,0,1,2.67,7.31,17.62,17.62,0,0,1-1.43,7.65c-3.57,9.61-9.73,18.53-10.43,28.76a4.65,4.65,0,0,0,.75,3.42,4.3,4.3,0,0,0,2.58,1.16c10.8,1.85,20.14-7.72,25.41-17.33A81.24,81.24,0,0,0,692.36,224c1.09-20.36-6.21-40.39-5.76-60.77C687.12,140.06,697.59,116.73,691.46,94.38Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M692.46,93.38c-.57-2.09-1.36-4.26-3-5.66a12.28,12.28,0,0,0-5.28-2.16A104.32,104.32,0,0,0,670.3,82.9a22.22,22.22,0,0,0-3-6.23C657.5,62.83,643,49.78,625.94,46.83c-8.93-1.55-19.28-.16-25,6.88-3.14,3.87-4.49,9-7.66,12.8-6.11,7.38-17.14,8.29-24.84,14-4.11,3-7.09,7.35-10,11.57-3.15,4.57-6.39,9.33-7.39,14.79-2,10.91,5.21,21.31,6.54,32.32,3,24.63-23.4,46.48-18.41,70.78,2.91,14.17,16,24.15,29.54,29.21,4.77,1.79,10.22,3.57,12.45,8.15,1,2,1.17,4.31,2.11,6.33,3.16,6.74,13.55,7,19.13,2.09s7.34-12.85,8-20.26c2.68-32.36-10.28-64.33-8.77-96.77.45-9.81,3.21-20.94,12-25.38,11.83-6,26.06,4,39.08,2.09a77.53,77.53,0,0,1,3.74,47.31c-2.07,8.63-5.65,17-5.91,25.9-.39,13.55,6.92,25.93,13.24,37.91a20.17,20.17,0,0,1,2.67,7.31,17.62,17.62,0,0,1-1.43,7.65c-3.57,9.61-9.73,18.53-10.43,28.76a4.65,4.65,0,0,0,.75,3.42,4.3,4.3,0,0,0,2.58,1.16c10.8,1.85,20.14-7.72,25.41-17.33A81.24,81.24,0,0,0,693.36,223c1.09-20.36-6.21-40.39-5.76-60.77C688.12,139.06,698.59,115.73,692.46,93.38Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#3e373a"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "581.79 492.73 621.46 494 615.77 464.58 585.38 467.47 581.79 492.73",
    fill: "#c3c7d9"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M793.29,466.42c-2.67,3.33-13,9.33-14,11.33s-13.33,8-19.67,9-26.33,5.34-30,7.67c-2.63,1.68-23.74,7-37.61,9.95a106.75,106.75,0,0,1-11.39,2.05c-6,.33-71.66-22-71.66-22l12.66-13,.7-.24c3.58-1.21,20.12-6.8,29.3-9.46,10.34-3,22.34-15.33,22.34-15.33s17.66-6,20-6.67-6-23.33-6-23.33,38.33-5.32,53.33-9.83,49.67-2.84,56,14.83S796,463.09,793.29,466.42Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#4b4b5b"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M618.62,522.75s-7.66,8-15.33,7.34-34.49,2-34.49,2a53.77,53.77,0,0,0-13.51,7.83c-6.27,4.94-9.6,1-10.22.16l-.11-.16c-3.34,10.51-11,2.5-11,2.5s3.33-32,2.31-36,6.59-10.87,6.59-10.87l9-2.29,22.8-5.84,32.67,11.33Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#e7c7ca"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M551.82,493.26l-6.75,46.82-.11-.16c-3.34,10.51-11,2.5-11,2.5s3.33-32,2.31-36,6.59-10.87,6.59-10.87Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M599,360.08s17.66,6,33,0",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M659.29,371.42s7.33,3.66,13,0",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M659.29,380.1s12.33,1.65,14.67-1.68",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M655.29,398.75s23.16-3,28.91-7",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M584.62,391.75s13,7.33,22.67,7",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M692,504.37a106.75,106.75,0,0,1-11.39,2.05c-6,.33-71.66-22-71.66-22l12.66-13,.7-.24c2,1.41,3.64,2.62,4.81,3.54,5.51,4.34,10.83-1.33,12.83-1.33s19.33,14.33,19.33,14.33,16,3.67,18.67,7,12,2.67,13.66,5C692.11,500.44,692.17,502.21,692,504.37Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M568.8,417.75s-16.18.93-25.51-3-40.33-13-49.33-6.63-30.67,12-20.67,37.34,14.67,26,14.67,26a36.1,36.1,0,0,1,8,8.3c3,4.67,31,15.33,38,15.33s19.33,0,36.66,12,33,13.34,33,13.34,22,9,28.85,11,38.15,10.66,45.49,8,12-19.34,12-19.34,3.33-15,1.66-17.33-11-1.67-13.66-5-18.67-7-18.67-7S642,476.42,640,476.42s-7.32,5.66-12.83,1.33a292.69,292.69,0,0,0-34.51-22C580,449.08,568.8,417.75,568.8,417.75Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#4b4b5b"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M536.27,427.42a19.1,19.1,0,0,1,16.39,4.33c8,6.67,34.92,20.06,34.92,20.06",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M736.29,427s-35.67,5.4-42.33,12.73",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M777.29,537.42l-1.57,0c-5.64-.2-24.75-.8-28.43,0-4.33,1-61.67,0-61.67,0l11.21-2.33s-4.16-14.58-1.52-15.79c0,0-15-9.88-3.69-16.55s23.5-3.86,23.5-3.86l28.39-9.62,5.45-1.85s32,1.67,40.66,23.67S777.29,537.42,777.29,537.42Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#e7c7ca"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M777.29,537.42l-1.57,0c9.31-7.68,30.37-31.06-32.21-48.1l5.45-1.85s32,1.67,40.66,23.67S777.29,537.42,777.29,537.42Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.88,
    cy: 466.33,
    r: 1.75,
    fill: "#4b4b5b"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 619.71,
    cy: 469.22,
    r: 1.75,
    fill: "#4b4b5b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M658.74,142.83A77.59,77.59,0,0,0,653,110.69c-13,1.94-27.24-8.09-39.08-2.09-8.76,4.44-11.51,15.57-12,25.38-.12,2.59-.14,5.18-.09,7.77,0-.92,0-1.85.09-2.77.46-9.81,3.21-20.94,12-25.38,11.84-6,26.06,4,39.08,2.09A77.38,77.38,0,0,1,658.74,142.83Z",
    transform: "translate(-88.58 -43.42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558,141a33.32,33.32,0,0,0-.13-6.54c-1.06-8.8-5.87-17.21-6.74-25.79-1.12,10.35,5.47,20.29,6.74,30.79C558,140,558,140.48,558,141Z",
    transform: "translate(-88.58 -43.42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.69,230.74c-.62,7.42-2.37,15.35-8,20.27s-16,4.65-19.13-2.09c-1-2-1.15-4.33-2.12-6.33-2.22-4.58-7.68-6.36-12.45-8.15-13.55-5.07-26.62-15-29.53-29.21a30.68,30.68,0,0,1-.53-3.9,31.52,31.52,0,0,0,.53,8.9c2.91,14.17,16,24.14,29.53,29.21,4.77,1.79,10.23,3.57,12.45,8.15,1,2,1.17,4.31,2.12,6.33,3.15,6.74,13.54,7,19.13,2.09s7.33-12.85,8-20.27A114.29,114.29,0,0,0,611,224C611,226.27,610.87,228.51,610.69,230.74Z",
    transform: "translate(-88.58 -43.42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.93,157.49c0,1.45,0,2.89,0,4.33.56-18.6,7.38-37.3,6.71-55.51C694.12,123.15,688.31,140.37,687.93,157.49Z",
    transform: "translate(-88.58 -43.42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.47,232.73a12.89,12.89,0,0,0,.23-3.61,20,20,0,0,0-2.67-7.31c-5.78-11-12.37-22.26-13.15-34.47,0,.52-.07,1-.08,1.56-.4,13.54,6.91,25.93,13.23,37.91A24,24,0,0,1,666.47,232.73Z",
    transform: "translate(-88.58 -43.42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.68,218.26a81.37,81.37,0,0,1-10.09,34.52c-5.28,9.61-14.61,19.18-25.42,17.33a4.25,4.25,0,0,1-2.58-1.17,2.5,2.5,0,0,1-.47-.78c-.12.78-.22,1.57-.28,2.37a4.61,4.61,0,0,0,.75,3.41,4.25,4.25,0,0,0,2.58,1.17c10.81,1.85,20.14-7.72,25.42-17.33a81.37,81.37,0,0,0,10.09-34.52c.12-2.34.13-4.67.06-7C693.72,216.93,693.72,217.59,693.68,218.26Z",
    transform: "translate(-88.58 -43.42)"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M695.31,519.3s25.31,10.62,42-12.88",
    transform: "translate(-88.58 -43.42)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    opacity: 0.1
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M700.29,537.86s20.67-13.44,47-.44",
    transform: "translate(-88.58 -43.42)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    opacity: 0.1
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M561.93,534.81s8.68-19.58,31.86-4.65",
    transform: "translate(-88.58 -43.42)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    opacity: 0.1
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M533.79,245.25l17.7-16s68.63-4.5,71.47,18.83c0,0,24.33-27.66,75.5-21.5l21.65,17.24-59.84,26.26-58.15,20.17-42.83-19.17Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M533.79,246.25l17.7-16s68.63-4.5,71.47,18.83c0,0,24.33-27.66,75.5-21.5l21.65,17.24-59.84,26.26-58.15,20.17-42.83-19.17Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#d5d6db"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "437.38 204.83 445.21 298.5 528.21 302.67 524.61 209.4 524.54 207.83 437.38 204.83",
    opacity: 0.1
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "437.38 202.83 445.21 296.5 528.21 300.67 524.61 207.4 524.54 205.83 437.38 202.83",
    fill: "#7342d6"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "635.33 202.83 549.71 215.67 549.71 309.76 633.38 297.67 635.33 202.83",
    opacity: 0.1
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "635.33 200.83 549.71 213.67 549.71 307.76 633.38 295.67 635.33 200.83",
    fill: "#7342d6"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "615.14 223.79 568.89 228.93 569.9 244.69 615.11 239.75 615.14 223.79",
    fill: "#fff",
    opacity: 0.3
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M538.29,390.08,543,402.75s7,6,14.66,3,14.34-4.49,17.67-7.41,8-17.59,8-17.59,4.67-16,9.33-20,17-59.11,0-53.72-30,55.39-30,55.39-3,3.66-7.33,4-13-.67-14.67,3S533.29,382.75,538.29,390.08Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#be6f72"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M638.29,259.08a28.8,28.8,0,0,1-25.11-6.26l3.61,93.26s8.5,9.2,21.5,7.1Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M638.29,257.08a28.8,28.8,0,0,1-25.11-6.26l3.61,93.26s8.5,9.2,21.5,7.1Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M638.29,257.08a28.8,28.8,0,0,1-25.11-6.26l3.61,93.26s8.5,9.2,21.5,7.1Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M640.29,246.57s34.83-10.65,43.91-9.15",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M601.33,241.92s-33.76-8-39.4-5.73",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M662.25,247.9s23.29-8.54,31.71-4.48",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M650.52,462.13A76.56,76.56,0,0,1,662,455c6-2.89,17-10.39,17-10.39",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M561.93,360.08s-14.61,11.95-19,13-7.1,10.37-7.1,10.37",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M715.32,388.3,710.66,401s-7,6-14.67,3-14.33-4.49-17.67-7.41-8-17.59-8-17.59-4.66-16-9.33-20-17-59.11,0-53.72,30,55.39,30,55.39,3,3.66,7.33,4,13-.67,14.67,3S720.32,381,715.32,388.3Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#be6f72"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M707.15,364.94s9.55,6.14,9.51,13.48",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 537.54,
    cy: 98.87,
    r: 44.67,
    fill: "#be6f72"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M598.07,130.3c5.42-.85,10.17-4,15.35-5.81,11.59-4.07,24.41-1.28,36.14,2.39,4.5,1.41,9.07,3,13.79,3s9.73-1.93,12.14-6c2.22-3.74,1.79-8.6-.08-12.53s-5-7.09-8.16-10.07c-10.4-9.82-23.3-19-37.57-18-5.74.41-11.23,2.46-16.51,4.73a182,182,0,0,0-19.38,9.76c-4.81,2.79-13.72,6.52-16.49,11.62C571,120.88,588.27,131.84,598.07,130.3Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#3e373a"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M675.49,119.68c-2.41,4.07-7.42,6-12.14,6s-9.29-1.53-13.8-2.94c-11.73-3.67-24.54-6.47-36.14-2.39-5.17,1.81-9.93,5-15.35,5.8-7.9,1.24-20.62-5.64-22-14.39-1.55,10.11,13.2,18.77,22,17.39,5.42-.85,10.18-4,15.35-5.8,11.6-4.08,24.41-1.28,36.14,2.39,4.51,1.41,9.07,3,13.8,2.94s9.73-1.92,12.14-6a11.71,11.71,0,0,0,1.4-7.31A10.78,10.78,0,0,1,675.49,119.68Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1038,661.63s5.93,7.75-2.74,19.46-15.81,21.59-12.93,28.89c0,0,13.08-21.74,23.72-22.05S1049.69,674.7,1038,661.63Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1038,661.63a9.6,9.6,0,0,1,1.21,2.43c10.38,12.2,15.92,23.59,5.93,23.87-9.3.27-20.45,16.9-23.12,21.09a9.78,9.78,0,0,0,.31,1s13.08-21.74,23.72-22.05S1049.69,674.7,1038,661.63Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1049,671.51c0,2.73-.31,4.94-.68,4.94s-.69-2.21-.69-4.94.38-1.44.76-1.44S1049,668.78,1049,671.51Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#ffd037"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.79,674.77c-2.39,1.3-4.48,2.09-4.66,1.76s1.61-1.66,4-3,1.45-.36,1.63,0S1055.19,673.46,1052.79,674.77Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#ffd037"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.66,661.63s-5.93,7.75,2.74,19.46,15.81,21.59,12.92,28.89c0,0-13.07-21.74-23.72-22.05S995,674.7,1006.66,661.63Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#7342d6"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.66,661.63a9.6,9.6,0,0,0-1.21,2.43c-10.38,12.2-15.92,23.59-5.93,23.87,9.29.27,20.45,16.9,23.12,21.09a7.72,7.72,0,0,1-.32,1s-13.07-21.74-23.72-22.05S995,674.7,1006.66,661.63Z",
    transform: "translate(-88.58 -43.42)",
    opacity: 0.1
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M995.64,671.51c0,2.73.3,4.94.68,4.94s.69-2.21.69-4.94-.39-1.44-.76-1.44S995.64,668.78,995.64,671.51Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#ffd037"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M991.86,674.77c2.39,1.3,4.48,2.09,4.66,1.76s-1.61-1.66-4-3-1.45-.36-1.63,0S989.46,673.46,991.86,674.77Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#ffd037"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 933.75,
    cy: 716.37,
    rx: 62,
    ry: 9.51,
    fill: "#7342d6",
    opacity: 0.1
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.24,699.53l-.3,2.42-.42,3.42-.17,1.43-.42,3.42-.18,1.43-.41,3.41-4.75,38.9c-.42,3.47-6.09,6.18-12.94,6.18H1010c-6.85,0-12.51-2.71-12.94-6.18l-4.75-38.9-.42-3.41-.17-1.43-.42-3.42-.18-1.43-.41-3.42-.3-2.42c-.23-2,2.83-3.62,6.71-3.62h50.42C1051.41,695.91,1054.48,697.56,1054.24,699.53Z",
    transform: "translate(-88.58 -43.42)",
    fill: "#65617d"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "965.36 658.53 964.95 661.95 902.55 661.95 902.13 658.53 965.36 658.53",
    fill: "#9d9cb5"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "964.77 663.38 964.36 666.8 903.14 666.8 902.72 663.38 964.77 663.38",
    fill: "#9d9cb5"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "964.18 668.23 963.76 671.65 903.73 671.65 903.32 668.23 964.18 668.23",
    fill: "#9d9cb5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawBooks);
export default __webpack_public_path__ + "static/media/Undraw_Books.64f45ed25262241aba12eff6dcb25d88.svg";
export { ForwardRef as ReactComponent };